import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import * as interfaceClassification from '@kentik/ui-shared/dictionary/interfaceClassification';

import { Box } from 'core/components';
import VerticalDetailTabs from 'app/components/detailTabs/VerticalDetailTabs';
import TabbedChart from 'app/components/tabbedChart/TabbedChart';
import Page from 'app/components/page/Page';
import InsightsMenu from 'app/components/navbar/InsightsMenu';

import AggregateViewHeader from '../aggregate/AggregateViewHeader';
import parentLinks from '../NetworkExplorerParentLink';

@inject('$tabs')
@observer
class NetworkBoundaryDetails extends Component {
  constructor(props) {
    super(props);

    const { $tabs } = props;
    const tabs = $tabs.getTabs();

    this.state.tabBlacklist = [tabs.NETWORK_BOUNDARY.id];
  }

  state = {
    filters: [],
    lookback_seconds: 86400,
    aggregateType: 'p95th_bits_per_sec'
  };

  get netBoundary() {
    const { match } = this.props;
    return match.params.netBoundary;
  }

  get networkBoundaryLabel() {
    return interfaceClassification.networkBoundaryTypes[this.netBoundary] || this.netBoundary;
  }

  handleLookbackChange = (lookback_seconds) => {
    this.setState({ lookback_seconds });
  };

  handleAggregationChange = (aggregateType) => {
    this.setState({ aggregateType });
  };

  get filters() {
    const { filters } = this.state;
    const detailFilter = {
      filterField: 'network_boundary',
      filterValue: this.netBoundary
    };

    return filters.concat(detailFilter);
  }

  handleFiltersApply = (filters) => {
    this.setState({ filters });
  };

  render() {
    const { aggregateType, filters, lookback_seconds, tabBlacklist } = this.state;

    return (
      <Page
        title={this.networkBoundaryLabel}
        parentLinks={[...parentLinks, { link: '/v4/core/quick-views/network-boundary', label: 'Network Boundaries' }]}
        insightsMenu={<InsightsMenu query="fetchNetworkBoundaryInsights" params={this.netBoundary} />}
        scrolls
        showExport
      >
        <AggregateViewHeader
          title={this.networkBoundaryLabel}
          aggregateType={aggregateType}
          filters={filters}
          lookbackSeconds={lookback_seconds}
          onFiltersChange={this.handleFiltersApply}
          onAggregateChange={this.handleAggregationChange}
          onMetricsChange={this.handleAggregationChange}
          onTimeRangeChange={this.handleLookbackChange}
        />
        <Box mb={2}>
          <TabbedChart overrides={{ lookback_seconds, aggregateTypes: [aggregateType] }} simpleFilters={this.filters} />
        </Box>

        <VerticalDetailTabs
          blacklist={tabBlacklist}
          simpleFilters={this.filters}
          queryOverrides={{ lookback_seconds, aggregateTypes: [aggregateType] }}
        />
      </Page>
    );
  }
}

export default NetworkBoundaryDetails;
